import { useEndToEndTestId } from '@perpay-web/hooks/useEndToEndTestId';
import { useIsMobile } from '@perpay-web/hooks/useIsMobile';
import { getClassName } from '@perpay-web/utils/domUtils';
import { noop } from '@perpay-web/utils/noop';

import styles from './AddressInput.scss';

const AddressInputListItem = ({
    item = null,
    renderProps,
    index,
    enterAddressManually = false,
    onItemClick = noop,
}) => {
    const { highlightedIndex, onSelect: onSelectItem } = renderProps;
    const { isMobile } = useIsMobile();
    const endToEndTestIDParams = useEndToEndTestId();

    const onClick = () => {
        onItemClick();
        if (item) {
            onSelectItem(item.placeId, item.line1);
        }
    };

    return (
        <li
            className={getClassName(
                styles.item,
                index === highlightedIndex && styles.highlighted,
            )}
            role='option'
            aria-selected={
                item || enterAddressManually ? index === highlightedIndex : null
            }
            {...endToEndTestIDParams}
        >
            <button
                className={getClassName(styles.combobox__dropdown__button)}
                onClick={onClick}
                type='button'
            >
                <div
                    className={
                        enterAddressManually
                            ? styles['manual-address-icon']
                            : styles['address-icon']
                    }
                />
                <div className={styles.item__text}>
                    <div
                        className={getClassName(
                            enterAddressManually
                                ? styles.item__text
                                : styles.item__text__primary,
                            !isMobile && styles['item-text-non-mobile'],
                        )}
                    >
                        {enterAddressManually ? (
                            <span className={styles.item__text__secondary}>
                                Don&apos;t see your address?
                            </span>
                        ) : (
                            item.line1
                        )}
                        {/* Legacy br tag. Do not copy! Use margin instead */}
                        {/* eslint-disable-next-line @perpay-web/no-jsx-br */}
                        {isMobile ? <br /> : ' - '}
                        {enterAddressManually ? (
                            <span
                                className={styles.item__text__manual__address}
                            >
                                Click here to enter address manually
                            </span>
                        ) : (
                            item.line2
                        )}
                    </div>
                </div>
            </button>
        </li>
    );
};

export default AddressInputListItem;
